import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const updateCoUserApi = createAsyncThunk('co-users/update', async ({ id, formData }, { getState, rejectWithValue }) => {
  const { loginToken, loginTokenCoUser } = getState();
  const authToken = loginToken?.response?.token || loginTokenCoUser?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/co-users/update/${id}`,
      {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: formData,
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const updateCoUser = createSlice(
  {
    name: 'deleteGroup',
    initialState,
    reducers: {},
    extraReducers: {
      [updateCoUserApi.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [updateCoUserApi.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [updateCoUserApi.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default updateCoUser;
